/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface PoliticalSponsorSummaryParams {
  network?: string;
  groupBy: string;
  page: number;
  pageSize: number;
}

@Injectable({providedIn: 'root'})
export class PoliticalSponsorApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  summary(params: PoliticalSponsorSummaryParams): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('politicalsponsors'),
      params
    });
  }
}
